export default "__VITE_ASSET__18416966__"